import * as React from 'react';
import {
    Dropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    Col,
    Container,
    Row
} from 'reactstrap';

import { CustomRangeDropdown } from './CustomRangeDropdown';

import {
    GetPriorMonthSubmissionHistoryRange,
    GetYtdSubmissionHistoryRange,
    GetCurrentMonthSubmissionHistoryRange,
    GetAllSubmissionHistoryRange,
    SubmissionHistoryRange,
    SubmissionHistoryRangeSelectionType,
    RangeTypeToDescription,
} from '../../Utils/SubmissionHistoryRange';

import { PortalTextSubmissionHistory } from '../../Models/Api/strongbox.financialportal';

type Props = {
    submissionHistoryRange: SubmissionHistoryRange;
    selectionType: SubmissionHistoryRangeSelectionType;
    searchButtonText: string;
    onRangeTypeChanged?: (newRangeType: SubmissionHistoryRangeSelectionType, newRange: SubmissionHistoryRange) => void;
    onSetSubmissionHistoryRange?: (range: SubmissionHistoryRange) => void;
    onExecuteSearch?: (range: SubmissionHistoryRange) => void;
    rangeSelectionOpen: boolean;
    toggleRangeSelectionOpen: () => void;
    closeRangeSelection: () => void;
    submissionHistoryText?: PortalTextSubmissionHistory;
};

export const SubmissionHistoryRangeSelection: React.FC<Props> = (props): React.ReactElement => {
    const {
        onRangeTypeChanged,
        onSetSubmissionHistoryRange,
        onExecuteSearch,
        searchButtonText,
        selectionType,
        submissionHistoryRange,
        rangeSelectionOpen,
        toggleRangeSelectionOpen,
        closeRangeSelection,
        submissionHistoryText,
    } = props;

    const [typeSelectionOpen, setTypeSelectionOpen] = React.useState<boolean>(false);

    const toggleTypeSelection = (): void => { setTypeSelectionOpen(!typeSelectionOpen); }

    const newSubmissionRange = (newRange: SubmissionHistoryRange): SubmissionHistoryRange => {
        if (!!newRange.end) {
            newRange.end.setHours(23, 59, 59, 999);
        }
        onSetSubmissionHistoryRange && onSetSubmissionHistoryRange(newRange);
        return newRange;
    }

    const newSelectionType = (newSelectionType: SubmissionHistoryRangeSelectionType): void => {
        if (newSelectionType === selectionType) {
            return;
        }

        let newRange: SubmissionHistoryRange = {
            ...submissionHistoryRange
        }
        switch (newSelectionType) {
            case 'allrange':
                newRange = GetAllSubmissionHistoryRange();
                break;
            case 'currentmonthrange':
                newRange = GetCurrentMonthSubmissionHistoryRange();
                break;
            case 'priormonthrange':
                newRange = GetPriorMonthSubmissionHistoryRange();
                break;
            case 'ytdrange':
                newRange = GetYtdSubmissionHistoryRange();
                break;
            case 'customrange':
                if (selectionType === 'allrange') {
                    newRange = GetCurrentMonthSubmissionHistoryRange();
                }
                break;
        }

        onRangeTypeChanged && onRangeTypeChanged(newSelectionType, newRange);

        if (newSelectionType !== 'customrange') {
            onExecuteSearch && onExecuteSearch(newRange);
        }
    }

    return (
        <Container fluid>
            <Row>
                <Col xs={'auto'}>
                    <Row>
                        <Col>
                            <Dropdown id={'selectionType'} isOpen={typeSelectionOpen} toggle={toggleTypeSelection}>
                                <DropdownToggle caret>
                                    {RangeTypeToDescription(selectionType, submissionHistoryText)}<span className={'spacer'} />
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem onClick={() => newSelectionType('allrange')}>{RangeTypeToDescription('allrange', submissionHistoryText)}</DropdownItem>
                                    <DropdownItem onClick={() => newSelectionType('currentmonthrange')}>{RangeTypeToDescription('currentmonthrange', submissionHistoryText)}</DropdownItem>
                                    <DropdownItem onClick={() => newSelectionType('priormonthrange')}>{RangeTypeToDescription('priormonthrange', submissionHistoryText)}</DropdownItem>
                                    <DropdownItem onClick={() => newSelectionType('ytdrange')}>{RangeTypeToDescription('ytdrange', submissionHistoryText)}</DropdownItem>
                                    <DropdownItem onClick={() => newSelectionType('customrange')}>{RangeTypeToDescription('customrange', submissionHistoryText)}</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </Col>
                        {
                            selectionType === 'customrange' && (
                                <Col xs={'auto'}>
                                    <CustomRangeDropdown
                                        searchButtonText={searchButtonText}
                                        submissionHistoryRange={submissionHistoryRange}
                                        onNewRange={range => newSubmissionRange(range)}
                                        onExecute={range => onExecuteSearch && onExecuteSearch(range)}
                                        rangeSelectionOpen={rangeSelectionOpen}
                                        toggleRangeSelectionOpen={toggleRangeSelectionOpen}
                                        closeRangeSelection={closeRangeSelection}
                                        submissionHistoryText={submissionHistoryText}
                                    />
                                </Col>
                            )
                        }
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}
